import template from "./photo-input.html";
import {photoInputController} from "./photo-input.controller";
import "./photo-input.scss";

export const photoInputComponent = {
    template,
    controller: photoInputController,
    controllerAs: "photoInput",
    bindings: {
        model: "=",
        isDisabled: "<",
        ratio: "@",
        customRatio: "<",
        layoutWidth: "<",
        layoutHeight: "<"
    }
};


// WEBPACK FOOTER //
// ./sources/components/common/photo-input/photo-input.component.js